import useAppSelector from 'hooks/useAppSelector';
import { isColorDark } from 'utils/colors';

const useNavIconColor = (): 'fillWhite' | 'fillBlack' => {
    const shopTheme = useAppSelector(({ shop }) => shop.info?.theme);

    const color =
        shopTheme?.mainBackgroundGradientEnabled && shopTheme?.mainBackgroundColorEnd
            ? shopTheme.mainBackgroundColorEnd
            : shopTheme?.mainBackgroundColor;

    return color && isColorDark(color) ? 'fillWhite' : 'fillBlack';
};

export default useNavIconColor;
